function AprobadasView({
  approvedTableFilters,
  updateApprovedTableFilter,
  approvedSearchTerm,
  setApprovedSearchTerm,
  estadoFilterOptions,
  metodoPagoFilterOptions,
  contactoFilterOptions,
  pendientePagoOptions,
  responsableFilterOptions,
  scopeOptions,
  activeScope,
  handleScopeChange,
  filterSummaryText,
  hasActiveFilters,
  handleClearFilters,
  approvedRequests,
  canManageUserSent,
  updatingUserSentById,
  userSentFeedbackById,
  handleUserSentChange,
  isWhatsappView,
  handleOpenWhatsappPreview,
  handleOpenAutomationUpload
}) {
  return (
    <section className="approved-view" data-ui-view="approved" data-ui-section="approved-view">
      <header>
        <h2>Facturas aprobadas y en proceso</h2>
        <p>Consulta todo el flujo postaprobación: aprobada, factura generada y enviada.</p>
      </header>

      <div className="scope-strip" data-ui-section="approved-scope-strip">
        {scopeOptions.map(option => (
          <button
            key={option.key}
            type="button"
            className={`scope-pill ${activeScope === option.key ? 'active' : ''}`}
            onClick={() => handleScopeChange(option.key)}
          >
            <span>{option.label}</span>
            <strong>{option.count}</strong>
          </button>
        ))}
      </div>

      <div className="table-filters table-filters-sticky" data-ui-section="approved-filters">
        <label className="filter-control">
          <span>Estado de solicitud</span>
          <select
            value={approvedTableFilters.estado}
            onChange={event => updateApprovedTableFilter('estado', event.target.value)}
          >
            {estadoFilterOptions.map(option => (
              <option key={`approved-estado-${option.value}`} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
        <label className="filter-control">
          <span>Método de pago</span>
          <select
            value={approvedTableFilters.metodoPago}
            onChange={event => updateApprovedTableFilter('metodoPago', event.target.value)}
          >
            {metodoPagoFilterOptions.map(option => (
              <option key={`approved-metodo-${option.value}`} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
        <label className="filter-control">
          <span>Contacto preferido</span>
          <select
            value={approvedTableFilters.contacto}
            onChange={event => updateApprovedTableFilter('contacto', event.target.value)}
          >
            {contactoFilterOptions.map(option => (
              <option key={`approved-contacto-${option.value}`} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
        <label className="filter-control">
          <span>Estado de pago</span>
          <select
            value={approvedTableFilters.pendientePago}
            onChange={event => updateApprovedTableFilter('pendientePago', event.target.value)}
          >
              {pendientePagoOptions.map(option => (
                <option key={`approved-pago-${option.value}`} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>
        <label className="filter-control">
          <span>Responsable</span>
          <select
            value={approvedTableFilters.responsable}
            onChange={event => updateApprovedTableFilter('responsable', event.target.value)}
          >
            {responsableFilterOptions.map(option => (
              <option key={`approved-responsable-${option.value}`} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
        <label className="filter-control search-control">
          <span>Búsqueda operativa</span>
          <input
            type="search"
            placeholder="Folio, RFC, ticket/OC, documento, periodo, correo, WhatsApp o responsable"
            value={approvedSearchTerm}
            onChange={event => setApprovedSearchTerm(event.target.value)}
          />
        </label>
        <div className="filter-summary-row">
          <p className="helper-text">{filterSummaryText}</p>
          {hasActiveFilters && (
            <button className="btn ghost compact" type="button" onClick={handleClearFilters}>
              Limpiar filtros
            </button>
          )}
        </div>
      </div>

      {!approvedRequests.length && <p className="helper-text">No hay facturas para los filtros y alcance seleccionados.</p>}

      <div className="approved-list" data-ui-section="approved-list">
        {approvedRequests.map(item => {
          const statusClass = (item.estado || '').toLowerCase().replace(/\s+/g, '-');
          const hasDownloadLink = Boolean(item.downloadUrl);
          const canToggleUserSent = Boolean(canManageUserSent && item.canToggleUserSent);
          const isUpdatingUserSent = Boolean(updatingUserSentById?.[item.airtableRecordId]);
          const userSentFeedback = userSentFeedbackById?.[item.airtableRecordId] || null;
          return (
            <article key={item.airtableRecordId || item.folio} className="approved-card">
              <div className="approved-card-main">
                <div className="approved-card-topline">
                  <div>
                    <h4>{item.folio}</h4>
                    <p>{item.clienteVisible}</p>
                  </div>
                  <span className={`status chip ${statusClass}`}>{item.estado}</span>
                </div>

                <div className="approved-card-details">
                  <span>
                    <strong>Total</strong>
                    {item.total}
                  </span>
                  <span>
                    <strong>Responsable</strong>
                    {item.responsable}
                  </span>
                  <span>
                    <strong>Contacto</strong>
                    {item.contacto}
                  </span>
                  <span>
                    <strong>Metodo</strong>
                    {item.metodoPagoCompacto || item.metodoPago}
                  </span>
                  {item.periodo && (
                    <span>
                      <strong>Periodo</strong>
                      {item.periodo}
                    </span>
                  )}
                  {item.numeroTicket && (
                    <span>
                      <strong>Ticket/OC</strong>
                      {item.numeroTicket}
                    </span>
                  )}
                  {item.nombreDocumento && (
                    <span>
                      <strong>Documento</strong>
                      {item.nombreDocumento}
                    </span>
                  )}
                  {item.rfc && (
                    <span>
                      <strong>RFC</strong>
                      {item.rfc}
                    </span>
                  )}
                </div>

                <div className="approved-chip-list">
                  <span className="approved-info-chip">{item.pendientePago}</span>
                  {item.contactarMediante && <span className="approved-info-chip subtle">{item.contactarMediante}</span>}
                  {item.enviadoPorUsuario && (
                    <span className="approved-info-chip success">Enviado por usuario</span>
                  )}
                </div>
              </div>
              <div className="approved-meta">
                <span>{item.actualizado}</span>
                <div className="approved-actions">
                  {item.primaryLinkUrl && (
                    <a className="btn ghost" href={item.primaryLinkUrl} target="_blank" rel="noreferrer">
                      {item.primaryLinkLabel}
                    </a>
                  )}
                  {isWhatsappView ? (
                    <button className="btn ghost" onClick={() => handleOpenWhatsappPreview(item)} disabled={!hasDownloadLink}>
                      Enviar por WhatsApp
                    </button>
                  ) : (
                    <button
                      className="btn ghost"
                      onClick={() => handleOpenAutomationUpload(item)}
                      disabled={!item.canUploadFiles}
                      title={item.uploadBlockedReason || ''}
                    >
                      {item.canUploadFiles ? 'Adjuntar archivos' : 'Carga bloqueada'}
                    </button>
                  )}
                </div>
                {canToggleUserSent && (
                  <div className="approved-user-sent-panel">
                    <label className={`approved-user-sent-toggle ${item.enviadoPorUsuario ? 'active' : ''}`}>
                      <input
                        type="checkbox"
                        checked={Boolean(item.enviadoPorUsuario)}
                        disabled={isUpdatingUserSent}
                        onChange={event => handleUserSentChange(item.airtableRecordId, event.target.checked)}
                        aria-label={`Marcar ${item.folio} como enviado por usuario`}
                      />
                      <span>{item.enviadoPorUsuario ? 'Enviado por usuario confirmado' : 'Marcar como enviado por usuario'}</span>
                    </label>
                    {isUpdatingUserSent && <span className="status-inline-message">Guardando…</span>}
                    {!isUpdatingUserSent && userSentFeedback && (
                      <span className={`status-inline-message ${userSentFeedback.type}`}>{userSentFeedback.message}</span>
                    )}
                  </div>
                )}
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default AprobadasView;
